module.exports = __webpack_public_path__ + "media/images/river/newyear-newyou-a442123bb45ae4dcd4ce7f57432949e3.jpg";